import React from 'react';
import { CHALLENGE_TYPES } from '../../common/constants';
import {
    numberWithCommas,
    unixTimestampToHumanReadable,
    getActiveChallengeStatus,
} from '../../common/utils';
import ButtonToNavigate from '../../common/ButtonToNavigate';

export const transformPartnerChallenges = (challenges) => {
    if (challenges && challenges.length) {
        return challenges.map(transformChallenge);
    } else {
        return [];
    }
};

function getBadgeTitle(challenge) {
    if (challenge.isGlobal) return CHALLENGE_TYPES.GLOBAL;
    else if (challenge.connected || challenge.parentChallenge)
        return CHALLENGE_TYPES.CONNECTED;
    else return CHALLENGE_TYPES.LOCAL;
}

export function transformConnectedChallenges(challenges) {
    // if challenge is not null and not empty object
    if (challenges && challenges.length) {
        return challenges.map((challenge) => transformChallenge(challenge));
    }
    return [];
}

export function transformChallenge(challenge) {
    // if challenge is not null and not empty object
    if (
        challenge &&
        Object.keys(challenge).length !== 0 &&
        challenge.constructor === Object
    ) {
        let transformedChallenge = {
            id: challenge.id,
            name: (
                <ButtonToNavigate
                    path={`/challenges/${challenge.id}`}
                    buttonText={<h2>{challenge.name}</h2>}
                    challenge={challenge}
                />
            ),
            circleRadius: challenge.circleRadius,
            title: challenge.name,
            description: challenge.mission,
            creatorId: challenge.creatorId,
            website: challenge.website,
            memberCount: challenge.memberCount,
            memberTarget: challenge.memberTarget,
            isGlobal: challenge.isGlobal,
            isMember: challenge.isMember,
            isPrivate: challenge.isPrivate,
            isConnected: challenge.connected || challenge.parentChallenge,
            thumbnail: challenge.profilePicture
                ? challenge.profilePicture
                : null,
            location: challenge.location,
            banner: challenge.banner ? challenge.banner : null,
            startDate: unixTimestampToHumanReadable(challenge.startDate),
            endDate: unixTimestampToHumanReadable(challenge.expiresAt),
            pickups: challenge.litterCount
                ? numberWithCommas(challenge.litterCount)
                : '0',
            target: challenge.litterQuantityTarget
                ? numberWithCommas(challenge.litterQuantityTarget)
                : '0',
            progress: Math.round(
                (challenge.litterCount / challenge.litterQuantityTarget) * 100,
            ),
            isActive: getActiveChallengeStatus(
                challenge.isPublished,
                challenge.expiresAt,
            ),
            badge: getBadgeTitle(challenge),
            createDate: unixTimestampToHumanReadable(challenge.createdAt),
            createdBy:
                challenge.user && challenge.user.name
                    ? challenge.user.name
                    : challenge.user && challenge.user.fullName
                    ? challenge.user.fullName
                    : '',
            creatorThumbnail: challenge.user
                ? challenge.user.profilePicture
                : '',
            type: challenge.type,
            partnerId: challenge.partnerId,
            isExpired: challenge.expiresAt < Date.now(),
            isPublished: challenge.isPublished,
            user: challenge.user.id,
        };
        return transformedChallenge;
    } else {
        return {
            id: '',
            name: '',
            title: '',
            description: '',
            isGlobal: false,
            isConnected: false,
            thumbnail: '',
            startDate: '',
            endDate: '',
            pickups: '0',
            target: '0',
            progress: 0,
            isActive: false,
            badge: getBadgeTitle(challenge),
            createDate: '',
            createdBy: '',
            creatorThumbnail: '',
        };
    }
}
